import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function HeroSection() {
  const featuredMovie = movies.find((m) => m.isHot && m.isNew) || movies[0];

  return (
    <section className="relative w-full h-[500px] md:h-[650px] overflow-hidden">
      <img
        src={featuredMovie.bannerImage}
        alt={featuredMovie.title}
        className="absolute inset-0 w-full h-full object-cover"
        title={featuredMovie.title}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/30 to-background-50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="flex items-center gap-3 mb-4">
          <span className="px-3 py-1 text-sm rounded-full bg-primary-500/90 text-foreground-50 font-medium backdrop-blur-sm">
            {featuredMovie.category}
          </span>
          <span className="px-3 py-1 text-sm rounded-full bg-accent-500/90 text-foreground-950 font-medium backdrop-blur-sm">
            热播推荐
          </span>
        </div>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 mb-4 max-w-3xl">
          {featuredMovie.title}
        </h1>
        <p className="text-foreground-200 text-sm md:text-base max-w-xl mb-6 leading-relaxed">
          {featuredMovie.description}
        </p>
        <div className="flex items-center gap-3 mb-8">
          <span className="flex items-center gap-1 text-accent-400">
            <i className="ri-star-fill"></i>
            <span className="font-semibold">{featuredMovie.rating}</span>
          </span>
          <span className="text-foreground-300">|</span>
          <span className="text-foreground-300">{featuredMovie.duration}</span>
          <span className="text-foreground-300">|</span>
          <span className="text-foreground-300">{featuredMovie.quality}</span>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to={`/article/${featuredMovie.id}`}
            className="px-8 py-3 rounded-full bg-primary-500 text-foreground-50 font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-fill mr-2"></i>
            立即观看
          </Link>
          <Link
            to={`/category/all`}
            className="px-8 py-3 rounded-full bg-background-50/30 text-foreground-100 font-medium hover:bg-background-50/50 backdrop-blur-sm transition-colors duration-200 whitespace-nowrap cursor-pointer border border-foreground-300/20"
          >
            浏览全部影片
          </Link>
        </div>
      </div>
    </section>
  );
}